import React from 'react';
import Flexbox from 'flexbox-react';
import FilledButtonWithDropdown from '../buttons-20250224T111359Z-001/buttons/ButtonWithDropdown.jsx';
import ScrollableDropdown from '../shared/ScrollableDropdown';
import { Divider } from "@blueprintjs/core";
import DepartmentKPITemplates from './DepartmentKPITemplates';
import { FilledButton } from '../buttons-20250224T111359Z-001/buttons';


const HeaderButtonsPanel = ({ selectedTimeframe, filteredGoalCycles, handleSelectTimeframe, handleSelectDepartmentTemplate, handleAddGoalClick, handleAddCascadingGoalClick, handleSendForApproval, isAccountOwner, goalList, isViewingOtherEmployee }) => {
    console.log({
        Flexbox,
        FilledButtonWithDropdown,
        FilledButton,
        ScrollableDropdown,
        DepartmentKPITemplates,
        Divider
    });
    return (
        <Flexbox flexDirection="row" gap="10px" justifyContent="flex-end" >
            {selectedTimeframe.is_editable && (
                <div style={{ display: "flex", gap: "10px", marginRight: "10px", alignItems: "center" }}>
                    <DepartmentKPITemplates
                        onSelectDepartment={handleSelectDepartmentTemplate}
                        buttonText="Use Templates"
                    />
                </div>
            )}
            {
                isAccountOwner ? (
                    <FilledButtonWithDropdown
                        text="Add Goal"
                        onClick={() => handleAddGoalClick()}
                        menuItems={[
                            {
                                text: "Add Goal",
                                icon: "add",
                                onClick: handleAddGoalClick
                            },
                            {
                                text: "Add Cascading Goal",
                                icon: "git-branch",
                                onClick: handleAddCascadingGoalClick
                            }
                        ]}
                    />
                ) : (
                    <FilledButton
                        text={"+ Add Goal"}
                        onClick={() => handleAddGoalClick()}
                        style={{ marginRight: "10px" }} />
                )
            }


            <div style={{ position: "relative", width: "250px" }}>
                <ScrollableDropdown
                    width={250}
                    label={selectedTimeframe.title || "Goal Cycle"}
                    items={filteredGoalCycles}
                    getKey={g => g.id}
                    getLabel={g => g.title}
                    enableSearch={true}
                    onSelect={handleSelectTimeframe}
                />
            </div>
            <Divider className="push-10-l push-10-r" vertical="true"></Divider>

            {!isViewingOtherEmployee() && selectedTimeframe.is_editable && goalList.length > 0 && (
                <FilledButton
                    text={selectedTimeframe.is_goal_approval_required ? "Send for Approval" : "Publish"}
                    onClick={() => handleSendForApproval()}
                    style={{ marginRight: "10px" }}
                />
            )}
        </Flexbox>
    );
};

export default HeaderButtonsPanel;